exports.f = require('./_wks');


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_wks-ext.js
 ** module id = 237
 ** module chunks = 0
 **/